<template>
    <v-dialog
        ref="dialog"
        v-model="isShow"
        v-if="isShow"
        :confirm-loading="confirmLoading"
        @confirm="onConfirm"
        :kind="kind"
        :class="{'vm-sysSelect-dialog': editSysAdmin}"
        title="选择员工"
    >
        <v-status-bar
            v-if="showQQTip"
            kind="slight-warning"
            style="margin-bottom: 20px;"
        >
            <span>给未分配QQ员工号的员工赋予该角色后，将自动给这些员工分配QQ员工号</span>
        </v-status-bar>
        <div
            v-spinner="!isShowSelect"
            :class="['vm-select-box', editSysAdmin ? 'vm-sysSelect-box': '']"
        >
            <v-spinner :opacity="0.5" />
            <vm-select-business
                v-if="isShowSelect"
                :config="selectorConfig"
                :hooks="selectorHooks"
                @change="onSelectChange"
                @submit="onSubmit"
                @cancel="onCancel"
            />
        </div>
    </v-dialog>
</template>

<script>
import Gateway from '@/utils/Gateway';
import VmSelectBusiness from 'src/components/vm-select-business-v3';

export default {
    components: {
        VmSelectBusiness,
    },

    props: {
        editSysAdmin: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isShow: false,
            isShowSelect: false,
            roleId: -1,
            showQQTip: false,
            hisSelectedIdSet: {},
            confirmLoading: false,
            selectedList: [],
            selectorHooks: {
                colleague: {
                    // 数据源类型
                    // 构建节点的事件，
                    onNodeBuild: (node) => {
                        this.disableHandle(node.data);
                        return node;
                    },
                    // 搜索事件， 用于禁用搜索项
                    onSearch: (item) => {
                        this.disableHandle(item);
                        return item;
                    },

                    onSearchRequest: params => Gateway.post(
                        '/v1/org/searchStaff',
                        {
                            ...params,
                            needQQ: true,
                            roleId: this.roleId,
                            ...this.getSid(),
                        },
                        {
                            originRes: true,
                        }
                    ),

                    onDataRequest: params => Gateway.post(
                        '/v1/org/orgTree',
                        {
                            ...params,
                            needQQ: true,
                            roleId: this.roleId,
                            ...this.getSid(),
                        },
                        {
                            originRes: true,
                        }
                    ),
                },
            },
            sid: '',

        };
    },

    computed: {
        kind() {
            return this.editSysAdmin ? '' : 'confirm';
        },

        selectorConfig() {
            return {
                tabs: {
                    // 同事数据源标识
                    colleague: {
                        folderCanSelect: false, // 父节点是否可选
                    },
                },
                multiple: !this.editSysAdmin, // 多选/单选
                maxLength: 0, // 最大可选数 ，0 表示不限制,
                layout: {
                    search: true, // 是否展示搜索，默认true
                    list: true, // 是否展示列表 默认true
                    status: true, // 是否展示已选数。默认 true
                    action: {
                        btn: !!this.editSysAdmin,
                    },
                    selected: !this.editSysAdmin, // 是否展示已选列表， 默认true
                },
                withCheckbox: false, // 是否展示checkbox
            };
        },
    },
    methods: {
        getSid() {
            const curHrefSid = window.location.href.match(/sid=(\d*)/);
            const sid = curHrefSid ? curHrefSid[1] : '';
            return sid ? { sid } : '';
        },
        show(opts) {
            const { showQQTip, roleId } = opts || {};
            this.isShow = true;
            this.isShowSelect = false;
            this.showQQTip = showQQTip;
            this.roleId = roleId;

            Gateway.get('/v1/funcPrivilege/roleStaffList', {
                roleId: this.roleId, // 角色ID
            })
                .then((res) => {
                    const list = res.kfexts || [];

                    this.hisSelectedIdSet = {};
                    if (list && list.length > 0) {
                        list.forEach((v) => {
                            this.hisSelectedIdSet[v] = 1;
                        });
                    }

                    this.isShowSelect = true;
                })
                .catch((message) => {
                    this.$message.error(message || '获取角色已选员工列表失败');
                });

            // 如果获取已选员工列表7s后还是没返回, 直接显示选择器
            setTimeout(() => {
                this.isShowSelect = true;
            }, 7000);
        },

        hide() {
            this.isShow = false;
        },

        showConfirmLoading() {
            this.confirmLoading = true;
        },

        hideConfirmLoading() {
            this.confirmLoading = false;
        },

        disableHandle(data) {
            const { isParent, id, noPermission, kfext, qq, canNotSelect } = data || {};

            if (!isParent) {
                const itemId = id || kfext;

                if (noPermission === 1 || canNotSelect) {
                    data.disabled = true;
                    data.tips = '由于套餐限制，该员工无法使用当前角色';
                } else if (this.hisSelectedIdSet[itemId]) {
                    data.disabled = true;
                    data.tips = '已添加该员工';
                } else if (this.showQQTip && !Number(qq)) {
                    data.tips = '该员工没有QQ员工号，赋予该角色后，将自动给他分配QQ员工号';
                }
            }
        },

        onConfirm(e) {
            this.$emit('confirm', this.selectedList, e);
        },
        onSubmit(val) {
            this.selectedList = (Object.keys(val).length && val.colleague) ||  [];
            this.$emit('onSubmit', this.selectedList);
        },
        onCancel() {
            this.isShow = false;
        },
        onSelectChange(arr) {
            this.selectedList = arr;
        },
    },
};
</script>
<style>
.vm-select-box {
    width: 640px;
    height: 424px;
}
.vm-sysSelect-box {
    width: 500px;
    height: 535px;
}
.vm-sysSelect-dialog {
    .v-dialog__content {
        padding: 24px 4px 4px 4px;
    }
}

</style>
